/*
 * @Author: gongzhichao 18311120024@163.com
 * @Date: 2023-05-25 19:05:44
 * @LastEditors: gongzhichao 18311120024@163.com
 * @LastEditTime: 2024-05-22 12:08:48
 * @FilePath: \jyrg-web\src\request\requestThree.js
 * @Description: 测试服请求文件
 */
/**
 * @Author: gongzhichao
 * @Date: 2023
 * @Description: 测试服请求文件
 */

import axios from "axios";
import config from "../config";

const baseURL = config.baseThreeUrl[process.env.NODE_ENV];
const service = axios.create({ baseURL, timeout: 15000 });

service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    console.log(error);
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (
      response.status === 401 ||
      res.code === 20002 ||
      res.code === 401 ||
      res.code === 5000 ||
      res.code > 50000
    ) {
      return Promise.reject("error");
    } else {
      return response.data;
    }
  },
  (error) => {
    console.log("err" + error);
    return Promise.reject(error);
  }
);

export default service;
